import { cn } from '@/lib/utils';
import { Checkbox as CheckboxHeadless } from '@headlessui/react';

type CheckboxProps = {
  className?: string;
  classTick?: string;
  label?: string;
  checked?: boolean;
  onChange: (value: boolean) => void;
  required?: boolean;
  disabled?: boolean;
  name?: string;
  id?: string;
  value?: string;
};

export const Checkbox = ({
  className,
  classTick,
  label,
  checked,
  onChange,
  required = false,
  disabled = false,
  name,
  id,
  value,
}: CheckboxProps) => (
  <CheckboxHeadless
    className={cn(
      `group flex items-center gap-3 cursor-pointer`,
      className || '',
    )}
    checked={checked}
    onChange={onChange}
    disabled={disabled}
    name={name}
    id={id}
    value={value}
    data-required={required}
  >
    <span
      className={cn(
        `relative shrink-0 w-6 h-6 rounded-[6px] border-2 border-s-stroke2 transition-colors flex items-center justify-center before:absolute before:w-3.5 before:h-3.5 before:rounded-[4px] before:bg-primary-01 before:opacity-0 before:transition-opacity group-data-[hover]:border-primary-01/30 group-data-[checked]:border-primary-01/30 group-data-[checked]:before:opacity-100`,
        classTick || '',
      )}
    ></span>
    {label && <span className='text-button text-t-primary '>{label}</span>}
  </CheckboxHeadless>
);
